module.exports = "/_next/static/images/c0963b407670d5adbda379b8c0a7c1fe-boy-looking-to-the-front-lg@2x.jpg.webp";